import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classNames from 'classnames';

class QuoteFormSectionSignup extends React.Component {
  static defaultProps = {
    readOnly: false,
  };

  static propTypes = {
    readOnly: PropTypes.bool,
  };

  render() {
    const { readOnly, errors, touched } = this.props;

    return (
      <fieldset>
        <div className={'row'}>
          <div className="col-sm-5">
            <div
              className={classNames('form-group', {
                'with-error': touched.fullName && errors.fullName,
              })}
            >
              <label>Full Name</label>
              <Field name="fullName" className="form-control" type="text" disabled={readOnly} />
              {touched.fullName &&
                errors.fullName && <label className="error">{errors.fullName}</label>}
            </div>
          </div>
          <div className="col-sm-5">
            <div
              className={classNames('form-group', {
                'with-error': touched.companyName && errors.companyName,
              })}
            >
              <label>Company Name</label>
              <Field name="companyName" className="form-control" type="text" disabled={readOnly} />
              {touched.companyName &&
                errors.companyName && <label className="error">{errors.companyName}</label>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-5">
            <div
              className={classNames('form-group', {
                'with-error': touched.email && errors.email,
              })}
            >
              <label>Email Address</label>
              <Field name="email" className="form-control" type="text" disabled={readOnly} />
              {touched.email && errors.email && <label className="error">{errors.email}</label>}
            </div>
          </div>
          <div className="col-sm-5">
            <div
              className={classNames('form-group', {
                'with-error': touched.password && errors.password,
              })}
            >
              <label>Password</label>
              <Field name="password" className="form-control" type="password" disabled={readOnly} />
              {touched.password &&
                errors.password && <label className="error">{errors.password}</label>}
            </div>
          </div>
        </div>
      </fieldset>
    );
  }
}

export default QuoteFormSectionSignup;



// WEBPACK FOOTER //
// ./src/component/quote/QuoteFormSectionSignup/index.js